// extracted by mini-css-extract-plugin
module.exports = {"socialContainer":"style-module--socialContainer--1v4F-","socialIcons":"style-module--socialIcons--2B0hR"};